import {reverse} from '@utils/helper';

const POS_MAP = {
  pos_comment_bubble: {
    name: 'InteractionIcon',
    info: '/ajax/comment_bubble/info.json',
    set: '/ajax/comment_bubble/set.json',
    tips: '*评论气泡领取后，需在评论气泡背包中完成取消/更换佩戴。'
  },
  pos_basic_interaction_icon: {
    name: 'InteractionIcon',
    info: '/ajax/zhuan_ping_zan/info.json',
    set: '/ajax/zhuan_ping_zan/set.json',
    tips: '微博版本大于等于13.11.0支持转评赞icon替换功能，请您升级微博版本后体验。'
  },
  pos_main_bottom_icon: {
    name: 'BottomIcon',
    info: '/ajax/home_guide_skin/info.json'
  },
};
const REVERSE_POS_MAP = reverse(POS_MAP);

export { POS_MAP, REVERSE_POS_MAP };
